module.exports = __webpack_public_path__ + "static/slider-img-four-fbed205fea5a787b69ec24dee5c461a1.jpg";